const initialSixArtsList = [
  { id: 0, title: 'Big Bellies' },
  { id: 1, title: 'Lunar Landscape' },
  { id: 2, title: 'Terracota Army' },
];

export { initialSixArtsList };
